module.exports = __webpack_public_path__ + "img/school.19dd4eeb.svg";